import classes from "./Burger.module.scss";
import { ReactComponent as BurgerIcon } from "../../../assets/images/hamburger-icon.svg";
import clsx from "clsx";

const Burger = (props: React.SVGProps<SVGSVGElement>) => {
  const { className, ...rest } = props;

  return <BurgerIcon className={clsx(classes.burger, className)} {...rest} />;
};

export default Burger;
